const PrivacyPageDe = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Datenschutzerklärung</h1>
      
      <div className="prose max-w-none text-gray-600">
        <div className="mb-8">
          <p className="mb-4">
            Ihre Privatsphäre ist uns bei Map Prints wichtig. Wir haben diese Richtlinie erstellt, um klar zu erläutern, 
            wie wir Ihre Informationen sammeln, nutzen und schützen, wenn Sie mapprints.de besuchen oder unsere Dienste nutzen.
          </p>

          <p className="mb-4">
            Haben Sie Fragen? Wir sind für Sie da! Kontaktieren Sie uns jederzeit unter info@mapprints.de oder info.mapprints@gmail.com.
          </p>

          <div className="bg-gray-50 p-4 rounded-xl mb-6">
            <p className="text-sm">
              Zuletzt aktualisiert: 27. Januar 2025 | Verfügbar in: Deutsch, Englisch
            </p>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Kurzübersicht</h2>
          <p className="mb-4">
            Hier erfahren Sie das Wichtigste über den Umgang mit Ihren Daten:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Wir verwenden Cookies, um Ihr Browsing-Erlebnis zu verbessern (z.B. Speichern Ihrer Einstellungen)</li>
            <li>Wir speichern Strava- und GPX-Aktivitätsdaten, wenn Sie individuelle Drucke mit Aktivitäten erstellen</li>
            <li>Wir nutzen vertrauenswürdige Anbieter für Zahlungen</li>
            <li>Wir respektieren und schützen Ihre Strava-Daten</li>
          </ul>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Ihre Rechte nach DSGVO</h2>
          <p className="mb-4">
            Als EU-basiertes Unternehmen folgen wir strengen Datenschutzregeln. Wir sammeln und verwenden 
            Ihre Informationen nur, wenn:
          </p>
          
          <ul className="list-disc pl-6 mb-6">
            <li>Wir sie zur Erfüllung Ihrer Bestellung benötigen</li>
            <li>Sie uns Ihre Einwilligung gegeben haben</li>
            <li>Es für unsere berechtigten Geschäftsinteressen erforderlich ist</li>
            <li>Wir gesetzlich dazu verpflichtet sind</li>
          </ul>

          <div className="bg-blue-50 p-4 rounded-xl mb-6">
            <h3 className="font-semibold mb-2">Ihre Datenschutzrechte</h3>
            <p className="mb-3">Als EWR-Resident können Sie:</p>
            <ul className="list-disc pl-6">
              <li>Ihre Informationen einsehen oder aktualisieren</li>
              <li>Die Löschung Ihrer Daten beantragen</li>
              <li>Der Nutzung Ihrer Daten widersprechen</li>
              <li>Die Datenverarbeitung einschränken</li>
              <li>Ihre Daten übertragen</li>
              <li>Ihre Einwilligung widerrufen</li>
            </ul>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Wie wir Cookies verwenden</h2>
          <p className="mb-4">
            Cookies helfen uns, Ihr Erlebnis zu verbessern. Diese kleinen Dateien speichern Ihre Präferenzen und 
            helfen uns zu verstehen, wie Sie unsere Website nutzen. Hier erfahren Sie, wofür wir sie einsetzen:
          </p>

          <ul className="list-disc pl-6 mb-4">
            <li>Speichern Ihrer Präferenzen</li>
          </ul>

          <p className="mb-4">
            Keine Sorge - Cookies können nicht auf Ihren Computer zugreifen oder Informationen abrufen, die Sie nicht freigegeben haben.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Website-Analyse</h2>
          <p className="mb-4">
            Wir verwenden Google Analytics, um zu verstehen, wie Sie unsere Website nutzen und unseren Service zu verbessern.
            Google Analytics sammelt Standard-Protokollinformationen wie Ihre IP-Adresse, Browsertyp, besuchte Seiten und Verweilzeiten.
          </p>
          <p className="mb-4">
            <strong>Datenschutz:</strong> Google Analytics wird erst aktiviert, wenn Sie Ihre ausdrückliche Zustimmung geben.
            Ohne Ihre Zustimmung werden keine Analytics-Daten erfasst oder an Google übermittelt. Sie können Ihre Zustimmung
            jederzeit in Ihren Cookie-Einstellungen ändern.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Umgang mit Ihren Zahlungsinformationen</h2>
          <p className="mb-4">
            Wir nutzen Stripe, einen vertrauenswürdigen Zahlungsdienstleister, für alle finanziellen Transaktionen. Weitere Informationen zur Zahlungssicherheit finden Sie in der Datenschutzerklärung 
            von Stripe. Der gesamte Datenverkehr auf  https://mapprints.de ist SSL-verschlüsselt.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Bestellinformationen</h2>
            <p className="mb-4">
              Derzeit generieren und liefern wir nur digitale Karten. Für digitale Karten zum selberdrucken werden keine personenbezogenen Daten von https://mapprints.de benötigt.
            </p>
            <p className="mb-4">
              In Zukunft, wenn wir gedruckte Bilder einführen, werden wir Versandinformationen wie Ihren Namen und 
              Ihre Lieferadresse benötigen. Wir werden diese Datenschutzerklärung entsprechend aktualisieren, 
              sobald dieser Service verfügbar wird.
            </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Ihre Aktivitätsdaten</h2>
          <p className="mb-4">
            Wenn Sie einen individuellen Druck erstellen, speichern wir Ihre Designdaten sicher. Dazu gehören:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Hochgeladene GPX- oder FIT-Dateien</li>
            <li>Strava-Aktivitäten, die Sie geteilt haben</li>
            <li>Individuelle Design-Präferenzen</li>
          </ul>
          <p className="mb-4">
            Wir verwenden diese Informationen ausschließlich zur Erstellung Ihres Drucks und werden sie niemals an Dritte weitergeben.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Geltungsbereich dieser Richtlinie</h2>
          <p className="mb-4">
            Diese Datenschutzerklärung gilt ausschließlich für unsere Website (mapprints.de) und umfasst keine 
            Offline-Interaktionen oder andere Websites.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Ihre Zustimmung</h2>
          <p className="mb-4">
            Durch die Nutzung von Map Prints stimmen Sie dieser Datenschutzerklärung zu. Wir empfehlen Ihnen, 
            sie regelmäßig zu überprüfen, da sie von Zeit zu Zeit aktualisiert werden kann.
          </p>
        </div>
      </div>
    </div>
  );
};
  
  const PrivacyPageEn = () => {
    return (
      <div className="container mx-auto px-4 py-8 max-w-3xl">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        
        <div className="prose max-w-none text-gray-600">
          <div className="mb-8">
            <p className="mb-4">
              Your privacy is important to us at Map Prints. We've created this policy to clearly explain 
              how we collect, use, and protect your information when you visit mapprints.de or use our services.
            </p>
  
            <p className="mb-4">
              Have questions? We're here to help! Reach out to us anytime at info@mapprints.de or info.mapprints@gmail.com.
            </p>
  
            <div className="bg-gray-50 p-4 rounded-xl mb-6">
              <p className="text-sm">
                Last updated: January 27, 2025 | Available in: German, English
              </p>
            </div>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Quick Overview</h2>
            <p className="mb-4">
              Here's what you need to know about how we handle your data:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>We use cookies to improve your browsing experience (eg. store your settings)</li>
              <li>We store Strava- and GPX-activity data in our database when you create custom prints with activities</li>
              <li>We use a trusted payment providers for payments</li>
              <li>We respect and protect your Strava data</li>
            </ul>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Your Rights Under GDPR</h2>
            <p className="mb-4">
              As a company based in the EU, we follow strict data protection rules. We only collect and use 
              your information when:
            </p>
            
            <ul className="list-disc pl-6 mb-6">
              <li>We need it to fulfill your order</li>
              <li>You've given us permission</li>
              <li>It's necessary for our legitimate business interests</li>
              <li>We're required by law</li>
            </ul>
  
            <div className="bg-blue-50 p-4 rounded-xl mb-6">
              <h3 className="font-semibold mb-2">Your Data Rights</h3>
              <p className="mb-3">As an EEA resident, you can:</p>
              <ul className="list-disc pl-6">
                <li>Access or update your information</li>
                <li>Request deletion of your data</li>
                <li>Object to how we use your data</li>
                <li>Restrict data processing</li>
                <li>Transfer your data</li>
                <li>Withdraw your consent</li>
              </ul>
            </div>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">How We Use Cookies</h2>
            <p className="mb-4">
              Cookies help us make your experience better. These small files remember your preferences and 
              help us understand how you use our website. Here's what we use them for:
            </p>
  
            <ul className="list-disc pl-6 mb-4">
              {/* <li>Analyzing which pages are most useful to visitors</li> */}
              {/* <li>Improving website performance</li> */}
              <li>Remembering your preferences</li>
            </ul>
  
            <p className="mb-4">
              Don't worry - cookies can't access your computer or any information you haven't chosen to share.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Website Analytics</h2>
            <p className="mb-4">
              We use Google Analytics to understand how you use our website and improve our service.
              Google Analytics collects standard log information such as your IP address, browser type, pages visited, and time spent on the site.
            </p>
            <p className="mb-4">
              <strong>Privacy:</strong> Google Analytics is only activated when you give us your explicit consent.
              Without your consent, no analytics data is collected or sent to Google. You can change your consent at any time in your cookie settings.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Handling Your Payment Information</h2>
            <p className="mb-4">
              We use Stripe, a trusted payment processor, to handle all financial transactions. For more information about payment security, 
              please check Stripe's Privacy Policy. All traffic on mapprints.de is secured via SSL.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Order Information</h2>
              <p className="mb-4">
                Currently, we only generate and deliver digital images. No personal information 
                is required for digital purchases on https://mapprints.de.
              </p>
              <p className="mb-4">
                In the future, when we introduce printed images, we will require shipping information 
                such as your name and delivery address. We'll update this privacy policy accordingly 
                when this service becomes available.
              </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Your Activity Data</h2>
            <p className="mb-4">
              When you create a custom print, we store your design data securely. This includes:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Uploaded GPX or FIT files</li>
              <li>Strava activities you've shared</li>
              <li>Custom design preferences</li>
            </ul>
            <p className="mb-4">
              We use this information solely to create your print and will never share it with third parties.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Scope of This Policy</h2>
            <p className="mb-4">
              This privacy policy applies exclusively to our website (mapprints.de) and doesn't cover 
              offline interactions or other websites.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Your Agreement</h2>
            <p className="mb-4">
              By using Map Prints, you agree to this privacy policy. We encourage you to review it 
              periodically, as it may be updated from time to time.
            </p>
          </div>
        </div>
      </div>
    );
  };

export {PrivacyPageDe, PrivacyPageEn};  